import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // progress display
  {
    path: '/',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/HomePage.vue'),
      },
    ],
  },

  // A_AboutUs
  {
    path: '/aboutus',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AboutUs',
        component: () => import('@/views/A_AboutUs/A-1_AboutUs.vue'),
      },
      {
        path: 'edit',
        name: 'AboutUsEdit',
        component: () => import('@/views/A_AboutUs/A-2_AboutUsEdit.vue'),
      },
    ],
  },

  // B-1__HomePage
  {
    path: '/homepage',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'HomePage',
        component: () =>
          import('@/views/B-1__HomePage/B-1-1-1_HomePage.vue'),
      },
      {
        path: 'edit',
        name: 'HomePageEdit',
        component: () =>
          import('@/views/B-1__HomePage/B-1-2-1_HomePageEdit.vue'),
      },
    ],
  },

  // B-2__Navigation
  {
    path: '/navigation',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Navigation',
        component: () =>
          import('@/views/B-2__Navigation/B-2-1__Navigation.vue'),
      },
      {
        path: 'edit',
        name: 'NavigationEdit',
        component: () =>
          import('@/views/B-2__Navigation/B-2-1-1__NavigationEdit.vue'),
      },
    ],
  },

  // B-3__BU Page
  {
    path: '/bupage',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'BUPage',
        component: () => import('@/views/B-3__BUPage/B-3__BUPageList.vue'),
      },
      {
        path: 'create',
        name: 'BUPageCreate',
        component: () => import('@/views/B-3__BUPage/B-3-1__BUPageCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'BUPageEdit',
        component: () => import('@/views/B-3__BUPage/B-3-2__BUPageEdit.vue'),
      },
      {
        path: ':id/edit/technology-detail-page/:detailId?',
        name: 'TechnologyDetailPage',
        component: () =>
          import('@/views/B-3__BUPage/B-3-2-6-1__TechnologyDetailPageEdit.vue'),
      },
      {
        path: 'edit/:id/application-detail-page/:detailId?',
        name: 'ApplicationDetailPage',
        component: () =>
          import('@/views/B-3__BUPage/B-3-2-7-1__ApplicationDetailPageEdit.vue'),
      },
      {
        path: 'edit/:id/quicktips-detail-page/:detailId?',
        name: 'QuicktipsDetailPage',
        component: () =>
          import('@/views/B-3__BUPage/B-3-2-8-1__QuicktipsDetailPageEdit.vue'),
      },
    ],
  },

  // B-4__CSR
  {
    path: '/csr-page',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'CSRPage',
        component: () => import('@/views/B-4__CSRPage/B-4__CSRPage.vue'),
      },
      {
        path: 'edit',
        name: 'CSRPageEdit',
        component: () => import('@/views/B-4__CSRPage/B-4__CSRPageEdit.vue'),
      },
      {
        path: 'edit/project-show-case',
        name: 'CSRProjectShowCasePageEdit',
        component: () =>
          import(
            '@/views/B-4__CSRPage/B-4-1-2-1__CSR_ProjectShowcasePageEdit.vue'
          ),
      },
    ],
  },
  // B-5__Carrer Page
  {
    path: '/career-page',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'CareerPage',
        component: () => import('@/views/B-5__CareerPage/B-5__CareerPage.vue'),
      },
      {
        path: 'edit',
        name: 'CareerPageEdit',
        component: () =>
          import('@/views/B-5__CareerPage/B-5__CareerPageEdit.vue'),
      },
      {
        path: 'edit/department-detail-edit',
        name: 'DepartmentDetailEdit',
        component: () =>
          import(
            '@/views/B-5__CareerPage/B-5-3-1-1__CareerEdit_DepartmentIntroductionPageEdit.vue'
          ),
      },
    ],
  },
  // B-6__contact
  {
    path: '/contact-worldwide-offices-list',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ContactPage',
        component: () => import('@/views/B-6__Contact/B-6-1__ContactPage.vue'),
      },
      {
        path: 'create',
        name: 'OfficeCreate',
        component: () =>
          import('@/views/B-6__Contact/B-6-1-1__OfficeCreate.vue'),
      },

      {
        path: ':id/edit',
        name: 'OfficeEdit',
        component: () => import('@/views/B-6__Contact/B-6-1-2__OfficeEdit.vue'),
      },

      {
        path: 'edit-contact-worldwide-offices-list',
        name: 'ContactPage_EditPageTitle',
        component: () =>
          import('@/views/B-6__Contact/B-6-1a_ContactPage_EditPageTitle.vue'),
      },
    ],
  },
  // B-7__SPortsLottery
  {
    path: '/sports-lottery',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SportsLotteryList',
        component: () =>
          import('@/views/B-7__SportsLottery/B-7-1__SportsLotteryList.vue'),
      },
      {
        path: 'create',
        name: 'SportLotteryInfoCreate',
        component: () =>
          import(
            '@/views/B-7__SportsLottery/B-7-1-1__SportsLotteryInfoCreate.vue'
          ),
      },
      {
        path: 'edit',
        name: 'SportLotteryInfoEdit',
        component: () =>
          import(
            '@/views/B-7__SportsLottery/B-7-1-2__SportsLotteryInfoEdit.vue'
          ),
      },
      {
        path: 'edit-sports-lottery-page-title',
        name: 'SportsLotteryEditPageTitle',
        component: () =>
          import(
            '@/views/B-7__SportsLottery/B-7-1-3__SportsLottery_EditPageTitle.vue'
          ),
      },
    ],
  },
  // B-8__AlertInfo
  {
    path: '/alert-info',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AlertInfo',
        component: () => import('@/views/B-8__AlertInfo/B-8__AlertInfo.vue'),
      },
      {
        path: 'edit',
        name: 'AlertInfoEdit',
        component: () => import('@/views/B-8__AlertInfo/B-8-1__AlertInfoEdit.vue'),
      },
    ],
  },
  // B-9__Privacy
  {
    path: '/privacy',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Privacy',
        component: () => import('@/views/B-9__Privacy/B-9-1__Privacy.vue'),
      },
      {
        path: 'edit',
        name: 'PrivacyEdit',
        component: () =>
          import('@/views/B-9__Privacy/B-9-1-1__PrivacyEdit.vue'),
      },
    ],
  },
  // B-10__TermOfUse
  {
    path: '/term-of-use',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'TermOfUse',
        component: () =>
          import('@/views/B-10__TermOfUse/B-10-1__TermOfUse.vue'),
      },
      {
        path: 'edit',
        name: 'TermOfUseEdit',
        component: () =>
          import('@/views/B-10__TermOfUse/B-10-1-1__TermOfUseEdit.vue'),
      },
    ],
  },
  // B-11__Social Resp
  {
    path: '/socialresp-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SocialRespCenter',
        component: () => import('@/views/B-11__SOCIALRESP/B-11__SocialRespCenter.vue'),
      },
      {
        path: 'create',
        name: 'SocialRespCreate',
        component: () => import('@/views/B-11__SOCIALRESP/B-11__SocialRespCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'SocialRespEdit',
        component: () => import('@/views/B-11__SOCIALRESP/B-11__SocialRespEdit.vue'),
      },
    ],
  },
  // B-12__News Banner+Video
  {
    path: '/banner-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'BannerCenter',
        component: () => import('@/views/B-12__SlideBanner/B-12__BannerCenter.vue'),
      },
      {
        path: 'create',
        name: 'BannerCreate',
        component: () => import('@/views/B-12__SlideBanner/B-12__BannerCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'BannerEdit',
        component: () => import('@/views/B-12__SlideBanner/B-12__BannerEdit.vue'),
      },
    ],
  },
  // B-13__Application
  {
    path: '/application-detail',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ApplicationCenter',
        component: () => import('@/views/B-13__ApplicationDetail/B-13__ApplicationCenter.vue'),
      },
      {
        path: 'create',
        name: 'ApplicationCreate',
        component: () => import('@/views/B-13__ApplicationDetail/B-13__ApplicationCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'ApplicationEdit',
        component: () => import('@/views/B-13__ApplicationDetail/B-13__ApplicationEdit.vue'),
      },
    ],
  },

  // C-1__Category
  {
    path: '/category',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Category',
        component: () =>
          import('@/views/C-1__Category/C-1__CategoriesList.vue'),
      },
      {
        path: 'create',
        name: 'CategoryCreate',
        component: () =>
          import('@/views/C-1__Category/C-1-1__Category-Create.vue'),
      },
      {
        path: 'category-info',
        name: 'CategoryInfo',
        component: () =>
          import('@/views/C-1__Category/C-1-2__CategoryInfo.vue'),
      },
      {
        path: 'category-info/:id/edit',
        name: 'CategoryInfoEdit',
        component: () =>
          import('@/views/C-1__Category/C-1-3__CategoryEdit.vue'),
      },
    ],
  },

  // C-2__SubCategory
  {
    path: '/sub-categories',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SubCategories',
        component: () =>
          import('@/views/C-2__SubCategory/C-2__SubCategoriesList.vue'),
      },
      {
        path: 'create',
        name: 'SubCategoryCreate',
        component: () =>
          import('@/views/C-2__SubCategory/C-2-9__SubCategoryCreate.vue'),
      },
      {
        path: 'sub-category-info/:id',
        name: 'SubCategoryInfo',
        component: () =>
          import('@/views/C-2__SubCategory/C-2-1__SubCategoryInfo.vue'),
      },
      {
        path: 'sub-category-info/:id/edit',
        name: 'SubCategoryInfoEdit',
        component: () =>
          import('@/views/C-2__SubCategory/C-2-2__SubCategoryEdit.vue'),
      },
    ],
  },

  // C-3__Product
  {
    path: '/products',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Products',
        component: () => import('@/views/C-3__Products/C-3__ProductList.vue'),
      },
      {
        path: 'create',
        name: 'ProductCreate',
        component: () =>
          import('@/views/C-3__Products/C-3-9__ProductInfoCreate.vue'),
      },
      {
        path: 'product-info/:id/edit',
        name: 'ProductInfoEdit',
        component: () =>
          import('@/views/C-3__Products/C-3-1__ProductInfoEdit.vue'),
      },
      {
        path: 'product-info/edit/edit-spec/:id',
        name: 'ProductInfoEditSpecEdit',
        component: () =>
          import(
            '@/views/C-3__Products/C-3-1a-4-1__ProductInfoEdit_Product Spec_Spec-Edit.vue'
          ),
      },
      {
        path: 'product-info/edit/edit-filter/:id',
        name: 'ProductInfoEditFilterEdit',
        component: () =>
          import(
            '@/views/C-3__Products/C-3-1a-4-2__ProductInfoEdit_Product Spec_Filter-Edit.vue'
          ),
      },
    ],
  },

  // C-4__ProductDownload
  {
    path: '/product-download',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ProductDownload',
        component: () =>
          import('@/views/C-4__ProductDownload/C-4-1__ProductDownload.vue'),
      },
      {
        path: 'create',
        name: 'ProductDownloadCreate',
        component: () =>
          import(
            '@/views/C-4__ProductDownload/C-4-1-1__ProductDownload-Create.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'ProductDownloadEdit',
        component: () =>
          import(
            '@/views/C-4__ProductDownload/C-4-1-2__ProductDownload-Edit.vue'
          ),
      },
    ],
  },

  // D_Awards
  {
    path: '/awards',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AwardList',
        component: () => import('@/views/D_Awards/D-1__AwardsList.vue'),
      },
      {
        path: 'award-info',
        name: 'AwardInfo',
        component: () => import('@/views/D_Awards/D-2__AwardInfo.vue'),
      },
      {
        path: 'award-info/:id/edit',
        name: 'AwardEdit',
        component: () => import('@/views/D_Awards/D-3__AwardEdit.vue'),
      },
      {
        path: 'create',
        name: 'AwardCreate',
        component: () => import('@/views/D_Awards/D-9__AwardCreate.vue'),
      },
      {
        path: 'edit-award-page-title',
        name: 'EditAwardPageTitle',
        component: () =>
          import('@/views/D_Awards/D-4__AwardsList_EditPageTitle.vue'),
      },
    ],
  },

  // E-4__News
  {
    path: '/news-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'NewsCenter',
        component: () => import('@/views/E-4__News/E-1__NewsCenter.vue'),
      },
      {
        path: 'create',
        name: 'NewsCreate',
        component: () => import('@/views/E-4__News/E-2__NewsCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'NewsEdit',
        component: () => import('@/views/E-4__News/E-3__NewsEdit.vue'),
      },
      {
        path: 'edit-newscenter-page-title',
        name: 'NewsCenter_EditPageTitle',
        component: () =>
          import('@/views/E-4__News/E-4_NewsCenter_EditPageTitle.vue'),
      },
    ],
  },
  // E-5__Akamai
  {
    path: '/Akamai',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Akamai',
        component: () => import('@/views/E-5__Akamai/E-1__Akamai.vue'),
      },
    ],
  },
  // E-5__SuccessStory
  {
    path: '/story-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'StoryCenter',
        component: () => import('@/views/E-5__SuccessStory/E-1__SuccessStoryCenter.vue'),
      },
      {
        path: 'create',
        name: 'StoryCreate',
        component: () => import('@/views/E-5__SuccessStory/E-2__SuccessStoryCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'StoryEdit',
        component: () => import('@/views/E-5__SuccessStory/E-3__SuccessStoryEdit.vue'),
      },
    ],
  },

  // E-6__SupportVideos
  {
    path: '/video-category',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'VideoCateCenter',
        component: () => import('@/views/E-6__SupportVideos/E-4__VideoCateCenter.vue'),
      },
      {
        path: 'create',
        name: 'VideoCateCreate',
        component: () => import('@/views/E-6__SupportVideos/E-5__VideoCateCreate.vue'),
      },
      {
        path: 'edit',
        name: 'VideoCateEdit',
        component: () => import('@/views/E-6__SupportVideos/E-6__VideoCateEdit.vue'),
      },
    ],
  },
  // E-6__SupportVideos
  {
    path: '/video-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SupportVideoCenter',
        component: () => import('@/views/E-6__SupportVideos/E-1__SupportVideoCenter.vue'),
      },
      {
        path: 'create',
        name: 'SupportVideoCreate',
        component: () => import('@/views/E-6__SupportVideos/E-2__SupportVideoCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'SupportVideoEdit',
        component: () => import('@/views/E-6__SupportVideos/E-3__SupportVideoEdit.vue'),
      },
    ],
  },

  // E-7__Technology
  {
    path: '/technology',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'TechnologyCenter',
        component: () => import('@/views/E-7__Technology/E-1__TechnologyCenter.vue'),
      },
      {
        path: 'create',
        name: 'TechnologyCreate',
        component: () => import('@/views/E-7__Technology/E-2__TechnologyCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'TechnologyEdit',
        component: () => import('@/views/E-7__Technology/E-3__TechnologyEdit.vue'),
      },
    ],
  },

  // E-8__TechCategory
  {
    path: '/tech-category',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'TechCategoryCenter',
        component: () => import('@/views/E-8__TechCategory/E-1__TechCategoryCenter.vue'),
      },
      {
        path: 'create',
        name: 'TechCategoryCreate',
        component: () => import('@/views/E-8__TechCategory/E-2__TechCategoryCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'TechCategoryEdit',
        component: () => import('@/views/E-8__TechCategory/E-3__TechCategoryEdit.vue'),
      },
    ],
  },

  // E-9__EDM
  {
    path: '/edms-center',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'EDMSCenter',
        component: () => import('@/views/E-9__Edms/E-1__EDMSCenter.vue'),
      },
      {
        path: 'create',
        name: 'EDMSCreate',
        component: () => import('@/views/E-9__Edms/E-2__EDMSCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'EDMSEdit',
        component: () => import('@/views/E-9__Edms/E-3__EDMSEdit.vue'),
      },
    ],
  },
  // F-1__ADATAmembers
  {
    path: '/adata-members',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ADATAmembers',
        component: () =>
          import('@/views/F-1__ADATAmembers/F-1__ADATA-members.vue'),
      },
      {
        path: 'member-info/:id',
        name: 'AdataMemberInfo',
        component: () =>
          import('@/views/F-1__ADATAmembers/F-1-1__ADATA-member-info.vue'),
      },
    ],
  },
  // F-2__EDMsubscriber
  {
    path: '/edm-subscribers',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'EDMsubscribers',
        component: () =>
          import('@/views/F-2__EDMsubscriber/F-2__EDMsubscribers.vue'),
      },
    ],
  },

  // G_Support
  {
    path: '/support-page',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Support',
        component: () => import('@/views/G_Support/G-1__Support.vue'),
      },
      {
        path: ':id/edit',
        name: 'SupportEdit',
        component: () => import('@/views/G_Support/G-1-1__SupportEdit.vue'),
      },
      {
        path: ':id/edit/edit-software',
        name: 'SupportEdit_B2C_Downloads_SoftwareEdit',
        component: () =>
          import(
            '@/views/G_Support/G-1-1b-1-a__SupportEdit_B2C_Downloads_SoftwareEdit.vue'
          ),
      },
      {
        path: ':id/edit/edit-warranty-policy-content',
        name: 'G-1-1b-3-1__SupportEdit_B2C_WarrantyPolicy_ContentEdit',
        component: () =>
          import(
            '@/views/G_Support/G-1-1b-3-1__SupportEdit_B2C_WarrantyPolicy_ContentEdit.vue'
          ),
      },
      {
        path: 'edit-support-page-title',
        name: 'EditSupportPageTitle',
        component: () => import('@/views/G_Support/EditSupportPageTitle.vue'),
      },
    ],
  },
  // G-5__SupportGroup ("群組管理", 從 SupportCategory 的「群組」下拉分類拉出獨立管理標題/副標題/圖片)
  {
    path: '/support-groups',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SupportGroupList',
        component: () => import('@/views/G-5__SupportGroup/G-1__SupportGroupList.vue'),
      },
      {
        path: 'edit',
        name: 'SupportGroupEdit',
        component: () => import('@/views/G-5__SupportGroup/G-2__SupportGroupEdit.vue'),
      },
    ],
  },
  // G-2__SupportCategory
  {
    path: '/support-category',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'SupportCategoryCenter',
        component: () => import('@/views/G-2__SupportCategory/G-1__SupportCategoryCenter.vue'),
      },
      {
        path: 'create',
        name: 'SupportCategoryCreate',
        component: () => import('@/views/G-2__SupportCategory/G-2__SupportCategoryCreate.vue'),
      },
      {
        path: 'edit',
        name: 'SupportCategoryEdit',
        component: () => import('@/views/G-2__SupportCategory/G-3__SupportCategoryEdit.vue'),
      },
    ],
  },
  // G-3__QACategory
  {
    path: '/faq-category',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'QACategoryCenter',
        component: () => import('@/views/G-3__QACategory/G-1__QACategoryCenter.vue'),
      },
      {
        path: 'create',
        name: 'QACategoryCreate',
        component: () => import('@/views/G-3__QACategory/G-2__QACategoryCreate.vue'),
      },
      {
        path: 'edit',
        name: 'QACategoryEdit',
        component: () => import('@/views/G-3__QACategory/G-3__QACategoryEdit.vue'),
      },
    ],
  },
  // 問與答
  {
    path: '/res-qa',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'QACenter',
        component: () => import('@/views/G-3__QACategory/G-4__QACenter.vue'),
      },
      {
        path: 'create',
        name: 'QACreate',
        component: () => import('@/views/G-3__QACategory/G-5__QACreate.vue'),
      },
      {
        path: 'edit',
        name: 'QAEdit',
        component: () => import('@/views/G-3__QACategory/G-6__QAEdit.vue'),
      },
    ],
  },
  // 檔案下載
  {
    path: '/res-download',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'FilesDownload',
        component: () =>
          import('@/views/G-4__DownloadResources/G-4-1__ProductDownload.vue'),
      },
      {
        path: 'create',
        name: 'FilesDownloadCreate',
        component: () =>
          import(
            '@/views/G-4__DownloadResources/G-4-1-1__ProductDownload-Create.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'FilesDownloadEdit',
        component: () =>
          import(
            '@/views/G-4__DownloadResources/G-4-1-2__ProductDownload-Edit.vue'
          ),
      },
    ],
  },

  // H_WhereToBuy
  {
    path: '/where-to-buy',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'WhereToBuy',
        component: () => import('@/views/H_WhereToBuy/H-1__WhereToBuy.vue'),
      },
      {
        path: 'create',
        name: 'WhereToBuyCreate',
        component: () =>
          import('@/views/H_WhereToBuy/H-1-1__WhereToBuyCreate.vue'),
      },
      {
        path: ':id/edit',
        name: 'WhereToBuyEdit',
        component: () =>
          import('@/views/H_WhereToBuy/H-1-9__WhereToBuyEdit.vue'),
      },
    ],
  },

  // I_IR Investor Relations
  {
    path: '/investor-relations',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'IR',
        component: () => import('@/views/I_IR/I_1-0__IR.vue'),
      },
      {
        path: 'edit',
        name: 'IR Edit',
        component: () => import('@/views/I_IR/I_1-0-0__IR-Edit.vue'),
      },
      {
        path: 'edit/edit-inner-page/:type',
        name: 'IRCorporateManagementEditinnerPage',
        component: () =>
          import('@/views/I_IR/I-0-3-1-1__IR-Corporate Management.vue'),
      },
      {
        path: 'detail-page/',
        name: 'IRFinacialInformationDetailPage',
        component: () =>
          import('@/views/I_IR/I-0-4-1__IR-Financial Information-Detail Page.vue'),
      },
      {
        path: 'detail-page/page-title-edit',
        name: 'IRFinacialInformationEditImage',
        component: () =>
          import(
            '@/views/I_IR/I-0-4-1-1__IR-Financial Information-Edit-Image.vue'
          ),
      },
      {
        path: 'detail-page/:id/edit-financial-information',
        name: 'EditFinancialInformation',
        component: () =>
          import('@/views/I_IR/I-0-4-1-2-1__IR-Financial Information_Edit.vue'),
      },
      {
        path: 'detail-page/create-financial-information',
        name: 'CreateFinancialInformation',
        component: () =>
          import(
            '@/views/I_IR/I-0-4-1-3-1__IR-Financial Information_Create.vue'
          ),
      },
    ],
  },

  // I-1__IR-InvestorFAQ
  {
    path: '/investor-faq',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'InvestorFAQList',
        component: () =>
          import('@/views/I-1__IR-InvestorFAQ/I-1-1__IR-InvestorFAQList.vue'),
      },
      {
        path: 'edit-investor-faq-page-title',
        name: 'EditInvestorFAQPageTitle',
        component: () =>
          import('@/views/I-1__IR-InvestorFAQ/EditInvestorFAQPageTitle.vue'),
      },
      {
        path: 'create',
        name: 'InvestorFAQCreate',
        component: () =>
          import(
            '@/views/I-1__IR-InvestorFAQ/I-1-1-1__IR-InvestorFAQCreate.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'InvestorFAQEdit',
        component: () =>
          import('@/views/I-1__IR-InvestorFAQ/I-1-1-2__IR-InvestorFAQEdit.vue'),
      },
    ],
  },

  // I-2_IR-LatestEvents
  {
    path: '/latest-events',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'LatestEvent',
        component: () =>
          import('@/views/I-2_IR-LatestEvents/I-2-1_IR-LatestEvents.vue'),
      },
      {
        path: 'edit-latest-event-page-title',
        name: 'EditLatestEventsPageTitle',
        component: () =>
          import('@/views/I-2_IR-LatestEvents/EditLatestEventPageTitle.vue'),
      },
      {
        path: 'create',
        name: 'LatestEventsCreate',
        component: () =>
          import(
            '@/views/I-2_IR-LatestEvents/I-2-1-1__IR-LatestEventsCreate.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'LatestEventsEdit',
        component: () =>
          import(
            '@/views/I-2_IR-LatestEvents/I-2-1-2__IR-LatestEventsEdit.vue'
          ),
      },
    ],
  },

  // I-3__IR-ShareholderMeeting
  {
    path: '/shareholder-meeting',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ShareholderMeeting',
        component: () =>
          import(
            '@/views/I-3__IR-ShareholderMeeting/I-3-1__IR-ShareholderMeeting.vue'
          ),
      },
      {
        path: 'edit-shareholder-meeting-page-title',
        name: 'EditShareholderMeetingPageTitle',
        component: () =>
          import(
            '@/views/I-3__IR-ShareholderMeeting/EditShareholderMeetingTitle.vue'
          ),
      },
      {
        path: 'create',
        name: 'ShareholderMeetingCreate',
        component: () =>
          import(
            '@/views/I-3__IR-ShareholderMeeting/I-3-1-1__IR-ShareholderMeetingCreate.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'ShareholderMeetingEdit',
        component: () =>
          import(
            '@/views/I-3__IR-ShareholderMeeting/I-3-1-2__IR-ShareholderMeetingEdit.vue'
          ),
      },
    ],
  },

  // I-4__IR-DividendHistoryCreate
  {
    path: '/dividend-history',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'DividendHistory',
        component: () =>
          import(
            '@/views/I-4__IR-DividendHistoryCreate/I-4-1__IR-DividendHistory.vue'
          ),
      },
      {
        path: 'edit-dividend-history-page-title',
        name: 'EditDividendHistoryPageTitle',
        component: () =>
          import(
            '@/views/I-4__IR-DividendHistoryCreate/EditDividendHistoryTitle.vue'
          ),
      },
      {
        path: 'create',
        name: 'DividendHistoryCreate',
        component: () =>
          import(
            '@/views/I-4__IR-DividendHistoryCreate/I-4-1-1__IR-DividendHistoryCreate.vue'
          ),
      },
      {
        path: ':id/edit',
        name: 'DividendHistoryEdit',
        component: () =>
          import(
            '@/views/I-4__IR-DividendHistoryCreate/I-4-1-2__IR-DividendHistoryEdit.vue'
          ),
      },
    ],
  },

  // I-5__IR-Email Alerts
  {
    path: '/email-alerts',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'EmailAlerts',
        component: () =>
          import('@/views/I-5__IR-EmailAlerts/I-5-1__IR-Email Alerts.vue'),
      },
      {
        path: 'edit-email-alerts-page-title',
        name: 'EditEmailAlertsPageTitle',
        component: () =>
          import('@/views/I-5__IR-EmailAlerts/EditEmailAlertsPageTitle.vue'),
      },
      {
        path: 'subscriber-page',
        name: 'EmailAlertsInfoPage',
        component: () =>
          import(
            '@/views/I-5__IR-EmailAlerts/I-5-1-1__IR-Email Alerts_Info Page.vue'
          ),
      },
      {
        path: ':id/subscriber-edit',
        name: 'EmailAlertsInfoEdit',
        component: () =>
          import(
            '@/views/I-5__IR-EmailAlerts/I-5-1-2__IR-Email Alerts_Info Edit.vue'
          ),
      },
      {
        path: 'subscriber-create',
        name: 'EmailAlertsInfoCreate',
        component: () =>
          import('@/views/I-5__IR-EmailAlerts/IR-Email Alerts_Info Create.vue'),
      },
    ],
  },

  // J__HR
  {
    path: '/human-resource',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'ResumeList',
        component: () => import('@/views/J__HR/J-1__HR_ResumeList.vue'),
      },
      {
        path: 'resume',
        name: 'Resume',
        component: () => import('@/views/J__HR/J-1-2a__HR_Resume.vue'),
      },
      {
        path: 'resume-edit',
        name: 'ResumeEdit',
        component: () => import('@/views/J__HR/J-1-2b__HR_Resume-Edit.vue'),
      },
    ],
  },

  // K__eNewsletter EDMlist
  {
    path: '/edm-send-list',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'EDMlist',
        component: () =>
          import('@/views/K__eNewsletterEDMlist/K-1-1_EDMlist.vue'),
      },
      {
        path: 'create',
        name: 'EDMlist_EDMCreate',
        component: () =>
          import('@/views/K__eNewsletterEDMlist/K-1-1-1_EDMlist_EDMCreate.vue'),
      },
      {
        path: 'edit',
        name: 'EDMlist_EDMEdit',
        component: () =>
          import('@/views/K__eNewsletterEDMlist/EDMlist_EDMEdit.vue'),
      },
    ],
  },

  // K__eNewsletter EDMreport
  {
    path: '/edm-report',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'EDMreport',
        component: () =>
          import('@/views/K__eNewsletterEDMreport/K-2-1_EDMreport.vue'),
      },
    ],
  },

  // L_MaterialGallery
  {
    path: '/material-gallery',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'MaterialGallery',
        component: () =>
          import('@/views/L_MaterialGallery/L-1__MaterialGallery.vue'),
      },
    ],
  },

  // M-1__AccountList
  {
    path: '/account-list',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AccountList',
        component: () =>
          import('@/views/M-1__AccountList/M-1__AccountList.vue'),
      },
      {
        path: 'account-edit',
        name: 'AccountListEdit',
        component: () =>
          import('@/views/M-1__AccountList/M-1-1__AccountList-Edit.vue'),
      },
    ],
  },

  // M-2__AccountLog
  {
    path: '/account-log',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AccountLog',
        component: () =>
          import('@/views/M-2__AccountLog/M-2__AccountLog.vue'),
      },
    ],
  },

  // Z__System Function
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Z-1__SystemFunction/Z-3_LogIn.vue'),
  },

  // Other
  {
    path: '/uispec',
    name: 'UISpec',
    component: () => import('../views/UISpec.vue'),
  },
  {
    path: '/loading',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Loading',
        component: () => import('@/components/PageLoading.vue'),
      },
    ],
  },

  {
    path: '*',
    component: () => import('@/components/Layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
export { routes };
